export default __webpack_public_path__ + "static/media/Route53.c6979c3e.svg";